import { closeLoader, openLoader } from '@utils/loader-util.js';
import apiClient from '@src/api/api-client.js';

export async function resetPickingCartUser() {
    openLoader();
    await apiClient.post('/be/picking-cart/reset-user');
    closeLoader();
}
